
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import type { PureImageSwiperConfig } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class SectionItemForth extends Vue {
  @Prop() config: PureImageSwiperConfig

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
